import {
  buildPracticeExample,
  PRACTICE_FOLLOWED_TICKET_ID,
  PRACTICE_STAGE,
} from 'src/services/consts/onboarding-practice.const'

// The example for the current run, the real user's fields it keeps, and where the set stands.
// All three are null or NONE until a run starts.
let example = null
let owner = null
let stage = PRACTICE_STAGE.NONE

// Builds the example for a new run, with the real user's id and settings copied in. Returns the
// example account at stage NONE, or null when there is no real account yet.
export function buildExampleAccount(realAccount) {
  if (!realAccount) return null

  owner = { userId: realAccount.userId, settings: realAccount.settings }
  example = buildPracticeExample(Date.now())
  stage = PRACTICE_STAGE.NONE
  return getPracticeAccount()
}

// Sets where the example set stands. Getters read the stage on each call.
export function setPracticeStage(nextStage) {
  stage = nextStage
}

// The followed request's version for the current stage: the draft, then the submitted one.
// Null before those stages.
function followedVersion(versions) {
  if (stage === PRACTICE_STAGE.DRAFT) return versions.draft
  if (stage === PRACTICE_STAGE.SUBMITTED) return versions.submitted
  return null
}

// Null when no run has built the example set. Vue Query rejects undefined, so never return it.
export function getPracticeAccount() {
  if (!example) return null

  const followedAccount = followedVersion(example.followedAccount)
  return {
    userId: owner.userId,
    settings: owner.settings,
    companies: example.companies,
    tickets: followedAccount ? [...example.tickets, followedAccount] : example.tickets,
    approvals: example.approvals,
    newTicketQuestions: example.newTicketQuestions,
  }
}

// The followed request as the wizard reads it. Null for any other id, and before its stage.
export function getPracticeTicket(ticketId) {
  if (ticketId !== PRACTICE_FOLLOWED_TICKET_ID) return null

  const ticket = followedVersion(example?.followedTicket ?? {})
  if (!ticket) return null

  const uploadedFiles = ticket.uploadedFiles.map((file) => ({ ...file, uploadedBy: owner.userId }))
  return { ...ticket, userId: owner.userId, uploadedFiles }
}

// The search results the walkthrough shows for "Otter", in the shape a real search returns.
export function getPracticeSearchResults() {
  return example?.searchResults ?? null
}

export function clearPracticeSource() {
  example = null
  owner = null
  stage = PRACTICE_STAGE.NONE
}
